// icon:home-assistant | Material Design Icons https://materialdesignicons.com/ | Austin Andrews
import * as React from "react";

function IconHomeAssistant(props) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" height="2.5em" width="2.5em" {...props}>
      <path d="M21.8 13H20v8h-7v-3.33l2.79-2.79.71.12a2.1 2.1 0 100-4.2 2.1 2.1 0 00-2.1 2.1l.1.71-1.5 1.52V9.65c.66-.36 1.1-1.05 1.1-1.85A2.1 2.1 0 0012 5.7a2.1 2.1 0 00-2.1 2.1c0 .8.44 1.49 1.1 1.85v5.48l-1.5-1.52.1-.71a2.1 2.1 0 00-2.1-2.1 2.1 2.1 0 00-2.1 2.1A2.1 2.1 0 007.5 15l.71-.12L11 17.67V21H4v-8H2.25c-.42 0-.83 0-.83-.21.01-.22.43-.64.86-1.07L11 3c.33-.33.67-.67 1-.67.33 0 .67.34 1 .67l4 4V6h2v3l2.78 2.78c.4.4.81.81.82 1.02 0 .2-.4.2-.8.2M7.5 12a.9.9 0 01.9.9.9.9 0 01-.9.9.9.9 0 01-.9-.9.9.9 0 01.9-.9m9 0c.5 0 .9.4.9.9s-.4.9-.9.9a.9.9 0 01-.9-.9.9.9 0 01.9-.9M12 6.9c.5 0 .9.4.9.9s-.4.9-.9.9-.9-.4-.9-.9.4-.9.9-.9z" />
    </svg>
  );
}

export default IconHomeAssistant;
